import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

/**
 * Flag modal: a flag is a marker plus a stored exception. It never changes the
 * release status, so nothing here can stall the payment process — the treasury
 * keeps working and the exception is what the report is built from.
 */
const AuditExceptionModal = ({
  show,
  onHide,
  onSubmit,
  categories = [],
  submitting = false,
  releaseLabel = "",
}) => {
  const [category, setCategory] = useState("");
  const [remark, setRemark] = useState("");
  const [error, setError] = useState("");

  // Each time the modal opens it starts blank; reusing the previous text on a
  // different release would be too easy to miss.
  useEffect(() => {
    if (show) {
      setCategory(categories[0] || "");
      setRemark("");
      setError("");
    }
  }, [show, categories]);

  const submit = (event) => {
    event.preventDefault();

    if (!category) {
      setError("Choose an exception category.");
      return;
    }
    if (remark.trim().length < 10) {
      setError("Describe the exception in at least 10 characters.");
      return;
    }

    setError("");
    onSubmit({ category, remark: remark.trim() });
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Form onSubmit={submit}>
        <Modal.Header closeButton>
          <Modal.Title className="h5">
            <FontAwesomeIcon icon={faExclamationTriangle} className="me-2 text-danger" />
            Flag this release
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {releaseLabel && (
            <p className="text-muted small mb-3">
              Recording an exception against <strong>{releaseLabel}</strong>. The release keeps
              its current status.
            </p>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Exception category</Form.Label>
            <Form.Select
              value={category}
              onChange={(event) => setCategory(event.target.value)}
              disabled={submitting}
            >
              <option value="">Select a category</option>
              {categories.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-0">
            <Form.Label>What is wrong?</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={remark}
              onChange={(event) => setRemark(event.target.value)}
              placeholder="Describe the exception so the treasury officer can act on it."
              disabled={submitting}
            />
            <Form.Text className="text-muted">At least 10 characters.</Form.Text>
          </Form.Group>

          {error && <div className="alert alert-danger mt-3 mb-0 py-2">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide} disabled={submitting}>
            Cancel
          </Button>
          <Button variant="danger" type="submit" disabled={submitting}>
            {submitting ? "Saving…" : "Record exception"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AuditExceptionModal;
